import { render, staticRenderFns } from "./GamesLeague.vue?vue&type=template&id=0a953458&scoped=true&"
import script from "./GamesLeague.vue?vue&type=script&lang=js&"
export * from "./GamesLeague.vue?vue&type=script&lang=js&"
import style0 from "./GamesLeague.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GamesLeague.vue?vue&type=style&index=1&id=0a953458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a953458",
  null
  
)

export default component.exports